var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "columns" }, [
      _c(
        "div",
        { staticClass: "column is-6" },
        [
          _c(
            "sc-field",
            [
              _c("sc-button", {
                attrs: {
                  text: "Adicionar método",
                  theme: "primary",
                  type: "button"
                },
                on: {
                  click: function($event) {
                    _vm.addConfigItem()
                  }
                }
              })
            ],
            1
          )
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "columns" }, [
      _c("div", { staticClass: "column" }, [
        _c(
          "div",
          { staticClass: "box" },
          [
            _c(
              "sc-table",
              {
                staticClass: "sc-files__table",
                attrs: {
                  data: _vm.clone_quoting_filtered,
                  bordered: true,
                  detailed: _vm.showDetails,
                  "detail-key": "order",
                  hoverable: false,
                  draggable: "",
                  "opened-detailed": _vm.openedDetail,
                  "show-detail-icon": true
                },
                on: {
                  dragstart: _vm.dragstart,
                  drop: _vm.drop,
                  dragover: _vm.dragover,
                  dragleave: _vm.dragleave
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(props) {
                      return [
                        _c(
                          "sc-table-column",
                          [_c("sc-icon", { attrs: { icon: "arrows-alt-v" } })],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "sc-table-column",
                          { attrs: { field: "priority", label: "Prioridade" } },
                          [
                            _vm._v(
                              "\n                  " +
                                _vm._s(props.row.priority) +
                                "\n              "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "sc-table-column",
                          {
                            attrs: { field: "name", label: "Descrição exibida" }
                          },
                          [
                            _c(
                              "sc-field",
                              [
                                _c("sc-input", {
                                  attrs: { placeholder: "Descrição" },
                                  model: {
                                    value: props.row.name,
                                    callback: function($$v) {
                                      _vm.$set(props.row, "name", $$v)
                                    },
                                    expression: "props.row.name"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm._t("table-fields", null, { props: props }),
                        _vm._v(" "),
                        _vm.showDetails
                          ? _c(
                              "sc-table-column",
                              { attrs: { label: "Adicionar Ações" } },
                              [
                                _c(
                                  "sc-field",
                                  [
                                    _c("sc-button", {
                                      attrs: {
                                        text: "Adicionar ações",
                                        theme: "primary",
                                        type: "button"
                                      },
                                      on: {
                                        click: function($event) {
                                          _vm.openDetail(props.row.order)
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "sc-table-column",
                          { attrs: { field: "status", label: "Ativo" } },
                          [
                            _c("sc-switch", {
                              model: {
                                value: props.row.status,
                                callback: function($$v) {
                                  _vm.$set(props.row, "status", $$v)
                                },
                                expression: "props.row.status"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "sc-table-column",
                          { attrs: { label: "Ações" } },
                          [
                            _c(
                              "sc-field",
                              [
                                _c("sc-button", {
                                  attrs: {
                                    theme: "danger",
                                    text: "X",
                                    type: "button"
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.remove(props.row.order, props.index)
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    }
                  },
                  {
                    key: "detail",
                    fn: function(props) {
                      return [
                        _c("sc-quoting-return-tbl-form-action", {
                          attrs: {
                            "action-form": props.row.default_new_action,
                            "only-show": false,
                            "config-index": props.index
                          },
                          on: { getactionevt: _vm.handleEvtAction }
                        }),
                        _vm._v(" "),
                        props.row.actions.length > 0
                          ? _c(
                              "div",
                              { staticClass: "detail_disabled" },
                              _vm._l(props.row.actions, function(
                                action,
                                actionIndex
                              ) {
                                return _c(
                                  "section",
                                  {
                                    key: actionIndex,
                                    staticClass: "detail_disabled--item"
                                  },
                                  [
                                    _c("sc-quoting-return-tbl-form-action", {
                                      attrs: {
                                        "action-form": action,
                                        "only-show": true,
                                        "config-index": props.index
                                      },
                                      on: { getactionevt: _vm.handleEvtAction }
                                    })
                                  ],
                                  1
                                )
                              })
                            )
                          : _vm._e()
                      ]
                    }
                  }
                ])
              },
              [
                _c(
                  "template",
                  { attrs: { slot: "empty" }, slot: "empty" },
                  [_c("sc-table-empty")],
                  1
                )
              ],
              2
            )
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "columns" }, [
      _c(
        "div",
        { staticClass: "column is-12 has-text-right" },
        [
          _c("sc-button", {
            ref: "salvarConfig",
            attrs: { type: "button", theme: "primary", text: "Salvar" },
            on: {
              click: function($event) {
                _vm.returnConfigList()
              }
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-13a27654", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13a27654","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-quote/features/quoting-return/components/sc-quoting-return-tbl/ScQuotingReturnTbl.vue
// module id = null
// module chunks = 